import axios, { AxiosResponse } from "axios";
import {
    CompleteSupportContactList,
    CompleteAdminSettings,
    CompleteUpdateAdminSettings,
    ReceiveSupportContactList,
    ReceiveSupportContactSettings,
    RequestSupportContactList,
    RequestUpdateAdminSettings,
    RequestSupportContactSettings,
    RequestAllRetentionPeriodsAction,
    ReceiveAllRetentionPeriodsAction,
    RequestRetentionSettings,
    ReceiveRetentionSettings,
    RequestPrimaryAdmin,
    CompletePrimaryAdmin,
    ReceivePrimaryAdmin,
    ReceiveMessageHistorySentItemsSettings,
    RequestFetchAdminSettings,
    ReceiveMessageHistoryReceivedItemsSettings,
    ReceiveAuthenticationSettings,
    ReceiveAuthenticationQuestionsSettings,
    ReceiveDropOffSettings,
    ReceiveNotificationsSettings,
    ReceiveRequestHistorySettings,
    ReceiveRequestNotificationSettings,
    RequestOneHubLink,
    ReceiveOneHubLink,
    CompleteOneHubLink,
    SavedMessageMailTemplateSettings,
    SavedMessageDRMailTemplateSettings,
    RequestOfficeLocationList,
    ReceiveOfficeLocationList,
    CompleteOfficeLocationList,
    ReceiveFolderNotificationsSettings,
    ReceiveFileTypeSettings,
} from "../../src/actions/adminSettingsActions";
import {
    IReceivedItemsHistorySettingsValues,
    IRequestHistorySettingsValues,
    ISentItemsHistorySettingsValues,
    ISupportContactSettingsValues,
    IRequestNotificationsSettings,
    IOfficeLocationResult,
    IFolderNotificationsSettings,
    IFileTypeSettings,
} from "../../src/reducers/adminSettingsReducer";
import { AppThunkAction } from "../../src/store";
import { actionTypes as adminSettingsActions } from "../../src/types/adminSettingsTypes";
import { actionTypes as notifactionAction } from "../../src/types/notificationTypes";
import { IAuthenticationMethodSettings } from "../../src/Core/ViewModels/Company/Settings/AuthenticationSettings";
import { ICompanyRetentionSettings } from "../../src/Core/ViewModels/Company/Settings/RetentionSettings";
import { CompanySettingsName } from "../../src/Core/Common/Enums";
import { StatusType, NotificationAction } from "../../src/store/Common/NotificationStore";
import { IMessageSecuritySettings } from "../../src/Core/ViewModels/Message/MessageSecurityQuestionModel";
import { IDropOffSettings } from "../../src/Core/ViewModels/Company/Settings/DropOffSettings";
import { AppNotifier } from "../../src/components/Common/Notification/AppNotifier";
import { INotificationsSettings } from "../../src/Core/ViewModels/Company/Settings/NotificationsSettings";
import { ToasterMessages } from "src/helper/ToasterMessages";
import {
    ISavedMessageDRTemplateSettings,
    ISavedMessageTemplateSettings,
} from "src/Core/ViewModels/settings/SavedMessageTemplate";

export type DispatchActions =
    | RequestOfficeLocationList
    | ReceiveOfficeLocationList
    | CompleteOfficeLocationList
    | RequestSupportContactList
    | CompleteSupportContactList
    | ReceiveSupportContactList
    | RequestUpdateAdminSettings
    | ReceiveSupportContactSettings
    | CompleteAdminSettings
    | RequestFetchAdminSettings
    | CompleteUpdateAdminSettings
    | RequestSupportContactSettings
    | RequestAllRetentionPeriodsAction
    | ReceiveAllRetentionPeriodsAction
    | RequestSupportContactSettings
    | ReceiveSupportContactList
    | RequestRetentionSettings
    | ReceiveRetentionSettings
    | RequestPrimaryAdmin
    | ReceivePrimaryAdmin
    | CompletePrimaryAdmin
    | ReceiveMessageHistorySentItemsSettings
    | ReceiveMessageHistoryReceivedItemsSettings
    | ReceiveAuthenticationSettings
    | ReceiveAuthenticationQuestionsSettings
    | ReceiveDropOffSettings
    | ReceiveNotificationsSettings
    | ReceiveRequestHistorySettings
    | ReceiveRequestNotificationSettings
    | RequestOneHubLink
    | ReceiveOneHubLink
    | CompleteOneHubLink
    | SavedMessageMailTemplateSettings
    | SavedMessageDRMailTemplateSettings
    | ReceiveFolderNotificationsSettings
    | ReceiveFileTypeSettings;

export type KnownActions = DispatchActions | NotificationAction;

export type UpdateAdminSettingsPayload =
    | ISupportContactSettingsValues
    | ICompanyRetentionSettings
    | ISentItemsHistorySettingsValues
    | IReceivedItemsHistorySettingsValues
    | IRequestHistorySettingsValues
    | IAuthenticationMethodSettings
    | IMessageSecuritySettings
    | IDropOffSettings
    | INotificationsSettings
    | IRequestNotificationsSettings
    | ISavedMessageTemplateSettings
    | ISavedMessageDRTemplateSettings
    | IFolderNotificationsSettings
    | IFileTypeSettings;

export const fetchOfficeLocationList =
    (callback?: any): AppThunkAction<KnownActions> =>
    dispatch => {
        dispatch({
            type: adminSettingsActions.REQUEST_OFFICE_LOCATION_LIST,
        });
        axios
            .get(`${process.env.REACT_APP_API_URL}/api/Company/office-location-list`)
            .then((response: IOfficeLocationResult) => {
                const data = response.data;
                dispatch({
                    type: adminSettingsActions.RECEIVE_OFFICE_LOCATION_LIST,
                    payload: data,
                });
                if (callback) {
                    callback(data);
                }
            })
            .catch(function (error: any) {
                dispatch({
                    type: notifactionAction.NOTIFICATION,
                    statusMessage: error.message,
                    statusType: StatusType.Error,
                });
                dispatch({
                    type: adminSettingsActions.COMPLETE_OFFICE_LOCATION_LIST,
                });
            });
    };

export const fetchContactList =
    (locationId = 0, callback: any = null): AppThunkAction<KnownActions> =>
    dispatch => {
        dispatch({
            type: adminSettingsActions.REQUEST_SUPPORT_CONTACT_LIST,
        });
        axios
            .get(`${process.env.REACT_APP_API_URL}/api/Contact/GetSupportContactList?locationId=${locationId}`)
            .then((response: any) => {
                const data = response.data;
                dispatch({
                    type: adminSettingsActions.RECEIVE_SUPPORT_CONTACT_LIST,
                    payload: data,
                });

                if (callback) {
                    callback(data);
                }
            })
            .catch(function (error: any) {
                dispatch({
                    type: notifactionAction.NOTIFICATION,
                    statusMessage: error.message,
                    statusType: StatusType.Error,
                });
                dispatch({
                    type: adminSettingsActions.COMPLETE_SUPPORT_CONTACT_LIST,
                });
            });
    };

export const updateAdminSettings =
    (
        name: CompanySettingsName,
        payload: UpdateAdminSettingsPayload,
        callback?: () => void
    ): AppThunkAction<KnownActions> =>
    dispatch => {
        dispatch({
            type: adminSettingsActions.REQUEST_UPDATE_ADMIN_SETTINGS,
        });

        axios
            .put(`${process.env.REACT_APP_API_URL}/api/Company/UpdateExchangeCompanySettings`, {
                name: name,
                value: JSON.stringify(payload),
            })
            .then(() => {
                dispatch({
                    type: adminSettingsActions.COMPLETE_UPDATE_ADMIN_SETTINGS,
                });
                if (callback) {
                    callback();
                }

                switch (name) {
                    case CompanySettingsName.SentMessageHistorySettings:
                        dispatch(fetchSentMessageHistorySettings());
                        break;
                    case CompanySettingsName.ReceivedMessageHistorySettings:
                        dispatch(fetchReceivedMessageHistorySettings());
                        break;
                    case CompanySettingsName.RetentionSettings:
                        dispatch(fetchRetentionSettings());
                        break;
                    case CompanySettingsName.RequestHistorySettings:
                        dispatch(fetchRequestHistorySettings());
                        break;
                    case CompanySettingsName.DropOffSettings:
                        break;
                    case CompanySettingsName.FileTypeSettings:
                        break;
                    default:
                        AppNotifier.Success(ToasterMessages.SUCCESS.APPLY_ADMIN_CHANGES);
                        break;
                }
            })
            .catch(function (error: any) {
                dispatch({
                    type: notifactionAction.NOTIFICATION,
                    statusMessage: error.message,
                    statusType: StatusType.Error,
                });
                dispatch({
                    type: adminSettingsActions.COMPLETE_UPDATE_ADMIN_SETTINGS,
                });
            });
    };

export const fetchSupportContactSettings =
    (callback?: any): AppThunkAction<KnownActions> =>
    dispatch => {
        dispatch({
            type: adminSettingsActions.REQUEST_FETCH_ADMIN_SETTINGS,
        });
        axios
            .get(`${process.env.REACT_APP_API_URL}/api/Company/GetSupportContactSettings`)
            .then((response: any) => {
                const data = response.data;
                dispatch({
                    type: adminSettingsActions.RECEIVE_SUPPORT_CONTACT_SETTINGS,
                    payload: data,
                });
                if (callback) {
                    callback(data);
                }
            })
            .catch(function (error: any) {
                dispatch({
                    type: notifactionAction.NOTIFICATION,
                    statusMessage: error.message,
                    statusType: StatusType.Error,
                });
                dispatch({
                    type: adminSettingsActions.COMPLETE_ADMIN_SETTINGS,
                });
            });
    };

export const fetchSentMessageHistorySettings = (): AppThunkAction<KnownActions> => dispatch => {
    dispatch({
        type: adminSettingsActions.REQUEST_FETCH_ADMIN_SETTINGS,
    });
    axios
        .get(`${process.env.REACT_APP_API_URL}/api/Company/GetSentMessageHistorySettings`)
        .then((response: any) => {
            const data = response.data;
            dispatch({
                type: adminSettingsActions.RECEIVE_MESSAGE_HISTORY_SENT_ITEMS_SETTINGS,
                payload: data,
            });
        })
        .catch(function (error: any) {
            dispatch({
                type: notifactionAction.NOTIFICATION,
                statusMessage: error.message,
                statusType: StatusType.Error,
            });
            dispatch({
                type: adminSettingsActions.COMPLETE_ADMIN_SETTINGS,
            });
        });
};

export const fetchReceivedMessageHistorySettings = (): AppThunkAction<KnownActions> => dispatch => {
    dispatch({
        type: adminSettingsActions.REQUEST_FETCH_ADMIN_SETTINGS,
    });
    axios
        .get(`${process.env.REACT_APP_API_URL}/api/Company/GetReceivedMessageHistorySettings`)
        .then((response: any) => {
            const data = response.data;
            dispatch({
                type: adminSettingsActions.RECEIVE_MESSAGE_HISTORY_RECEIVED_ITEMS_SETTINGS,
                payload: data,
            });
        })
        .catch(function (error: any) {
            dispatch({
                type: notifactionAction.NOTIFICATION,
                statusMessage: error.message,
                statusType: StatusType.Error,
            });
            dispatch({
                type: adminSettingsActions.COMPLETE_ADMIN_SETTINGS,
            });
        });
};

export const fetchRequestHistorySettings = (): AppThunkAction<KnownActions> => dispatch => {
    dispatch({
        type: adminSettingsActions.REQUEST_FETCH_ADMIN_SETTINGS,
    });
    axios
        .get(`${process.env.REACT_APP_API_URL}/api/Company/GetDocumentRequestHistorySettings`)
        .then((response: any) => {
            const data = response.data;
            dispatch({
                type: adminSettingsActions.RECEIVE_REQUEST_HISTORY_SETTINGS,
                payload: data,
            });
        })
        .catch(function (error: any) {
            dispatch({
                type: notifactionAction.NOTIFICATION,
                statusMessage: error.message,
                statusType: StatusType.Error,
            });
            dispatch({
                type: adminSettingsActions.COMPLETE_ADMIN_SETTINGS,
            });
        });
};

export const fetchRetentionSettings = (): AppThunkAction<KnownActions> => dispatch => {
    dispatch({
        type: adminSettingsActions.REQUEST_FETCH_ADMIN_SETTINGS,
    });
    axios
        .get(`${process.env.REACT_APP_API_URL}/api/Company/GetRetentionSettings`)
        .then((response: any) => {
            const data = response.data;
            dispatch({
                type: adminSettingsActions.RECEIVE_RETENTION_SETTINGS,
                payload: data,
            });
        })
        .catch(function (error: any) {
            dispatch({
                type: notifactionAction.NOTIFICATION,
                statusMessage: error.message,
                statusType: StatusType.Error,
            });
            dispatch({
                type: adminSettingsActions.COMPLETE_ADMIN_SETTINGS,
            });
        });
};

export const fetchAuthenticationMethodSettings =
    (callback?: (data: any) => void): AppThunkAction<KnownActions> =>
    dispatch => {
        dispatch({
            type: adminSettingsActions.REQUEST_FETCH_ADMIN_SETTINGS,
        });
        axios
            .get(`${process.env.REACT_APP_API_URL}/api/Company/GetAuthenticationMethodSettings`)
            .then((response: any) => {
                const data = response.data;
                dispatch({
                    type: adminSettingsActions.RECEIVE_AUTHENTICATION__SETTINGS,
                    payload: data,
                });
                if (callback) {
                    callback(data);
                }
            })
            .catch(function (error: any) {
                dispatch({
                    type: notifactionAction.NOTIFICATION,
                    statusMessage: error.message,
                    statusType: StatusType.Error,
                });
            })
            .finally(() => {
                dispatch({
                    type: adminSettingsActions.COMPLETE_ADMIN_SETTINGS,
                });
            });
    };

export const fetchNotificationsSettings = (): AppThunkAction<KnownActions> => dispatch => {
    dispatch({
        type: adminSettingsActions.REQUEST_FETCH_ADMIN_SETTINGS,
    });
    axios
        .get(`${process.env.REACT_APP_API_URL}/api/Company/GetNotificationsSettings`)
        .then((response: any) => {
            const data = response.data;
            dispatch({
                type: adminSettingsActions.RECEIVE_NOTIFICATIONS_SETTINGS,
                payload: data,
            });
        })
        .catch(function (error: any) {
            dispatch({
                type: notifactionAction.NOTIFICATION,
                statusMessage: error.message,
                statusType: StatusType.Error,
            });
            dispatch({
                type: adminSettingsActions.COMPLETE_ADMIN_SETTINGS,
            });
        });
};

export const fetchRequestNotificationsSettings = (): AppThunkAction<KnownActions> => dispatch => {
    dispatch({
        type: adminSettingsActions.REQUEST_FETCH_ADMIN_SETTINGS,
    });
    axios
        .get(`${process.env.REACT_APP_API_URL}/api/Company/GetDocumentRequestNotificationSettings`)
        .then((response: any) => {
            const data = response.data;
            dispatch({
                type: adminSettingsActions.RECEIVE_REQUESTNOTIFICATIONS_SETTINGS,
                payload: data,
            });
        })
        .catch(function (error: any) {
            dispatch({
                type: notifactionAction.NOTIFICATION,
                statusMessage: error.message,
                statusType: StatusType.Error,
            });
            dispatch({
                type: adminSettingsActions.COMPLETE_ADMIN_SETTINGS,
            });
        });
};

export const fetchPrimaryAdmin =
    (resourceId: string, callback?: any): AppThunkAction<KnownActions> =>
    dispatch => {
        dispatch({
            type: adminSettingsActions.REQUEST_PRIMARY_ADMIN,
        });
        axios
            .get(`${process.env.REACT_APP_API_URL}/api/Contact/GetPrimaryAdminForCompany`, {
                headers: { "X-Resource-Id": resourceId },
            })
            .then((response: any) => {
                const data = response.data;
                dispatch({
                    type: adminSettingsActions.RECEIVE_PRIMARY_ADMIN,
                });
                callback(data);
            })
            .catch(function (error: any) {
                dispatch({
                    type: notifactionAction.NOTIFICATION,
                    statusMessage: error.message,
                    statusType: StatusType.Error,
                });
                dispatch({
                    type: adminSettingsActions.COMPLETE_PRIMARY_ADMIN,
                });
            });
    };

export const requestAllRetentionPeriods =
    (reload = false): AppThunkAction<KnownActions> =>
    dispatch => {
        dispatch({
            type: adminSettingsActions.REQUEST_ALL_RETENTION_PERIODS,
        });
        if (reload) {
            axios
                .get(`${process.env.REACT_APP_API_URL}/api/Company/GetAllRetentionPeriodList`)
                .then((response: any) => {
                    const data = response.data;
                    dispatch({
                        type: adminSettingsActions.RECEIVE_ALL_RETENTION_PERIODS,
                        retentionPeriods: data,
                    });
                })
                .catch(function (error) {
                    dispatch({
                        type: notifactionAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                });
        }
    };

export const fetchMessageSecurityQuestionSettings = (): AppThunkAction<KnownActions> => dispatch => {
    dispatch({
        type: adminSettingsActions.REQUEST_FETCH_ADMIN_SETTINGS,
    });
    axios
        .get(`${process.env.REACT_APP_API_URL}/api/Company/GetMessageSecurityQuestionSettings`)
        .then((response: any) => {
            const data = response.data;
            dispatch({
                type: adminSettingsActions.RECEIVE_MESSAGE_SECURITY_QUESTIONS_SETTINGS,
                payload: data,
            });
        })
        .catch(function (error: any) {
            dispatch({
                type: notifactionAction.NOTIFICATION,
                statusMessage: error.message,
                statusType: StatusType.Error,
            });
        })
        .finally(() => {
            dispatch({
                type: adminSettingsActions.COMPLETE_ADMIN_SETTINGS,
            });
        });
};

export const fetchDropOffSettings = (): AppThunkAction<KnownActions> => dispatch => {
    dispatch({
        type: adminSettingsActions.REQUEST_FETCH_ADMIN_SETTINGS,
    });
    axios
        .get(`${process.env.REACT_APP_API_URL}/api/Company/GetDropOffSettings`)
        .then((response: AxiosResponse) => {
            const data = response.data;
            dispatch({
                type: adminSettingsActions.RECEIVE_DROP_OFF_SETTINGS,
                payload: data,
            });
        })
        .catch(function (error: any) {
            dispatch({
                type: notifactionAction.NOTIFICATION,
                statusMessage: error.message,
                statusType: StatusType.Error,
            });
            dispatch({
                type: adminSettingsActions.COMPLETE_ADMIN_SETTINGS,
            });
        });
};

export const fetchOnehubLink = (): AppThunkAction<KnownActions> => dispatch => {
    dispatch({
        type: adminSettingsActions.REQUEST_ONEHUB_LINK,
    });
    axios
        .get(`${process.env.REACT_APP_API_URL}/api/Company/GetCompanyOneHubLink`)
        .then((response: any) => {
            const data = response.data;
            dispatch({
                type: adminSettingsActions.RECEIVE_ONEHUB_LINK,
                payload: data.includes("https://") ? data : "",
            });
        })
        .catch(function (error: any) {
            dispatch({
                type: notifactionAction.NOTIFICATION,
                statusMessage: error.message,
                statusType: StatusType.Error,
            });
            dispatch({
                type: adminSettingsActions.COMPLETE_ONEHUB_LINK,
            });
        });
};

export const fetchSavedMessageMailTemplateSettings = (): AppThunkAction<KnownActions> => dispatch => {
    dispatch({
        type: adminSettingsActions.REQUEST_FETCH_ADMIN_SETTINGS,
    });
    axios
        .get(`${process.env.REACT_APP_API_URL}/api/Company/GetSavedMessageTemplateSettings`)
        .then((response: any) => {
            const data = response.data;
            dispatch({
                type: adminSettingsActions.RECEIVE_SAVED_MESSAGE_MAIL_TEMPLATE_SETTINGS,
                payload: data,
            });
        })
        .catch(function (error: any) {
            dispatch({
                type: notifactionAction.NOTIFICATION,
                statusMessage: error.message,
                statusType: StatusType.Error,
            });
        })
        .finally(() => {
            dispatch({
                type: adminSettingsActions.COMPLETE_ADMIN_SETTINGS,
            });
        });
};

export const fetchSavedMessageDRMailTemplateSettings = (): AppThunkAction<KnownActions> => dispatch => {
    dispatch({
        type: adminSettingsActions.REQUEST_FETCH_ADMIN_SETTINGS,
    });
    axios
        .get(`${process.env.REACT_APP_API_URL}/api/Company/GetSavedMessageDRTemplateSettings`)
        .then((response: any) => {
            const data = response.data;
            dispatch({
                type: adminSettingsActions.RECEIVE_SAVED_MESSAGE_DR_MAIL_TEMPLATE_SETTINGS,
                payload: data,
            });
        })
        .catch(function (error: any) {
            dispatch({
                type: notifactionAction.NOTIFICATION,
                statusMessage: error.message,
                statusType: StatusType.Error,
            });
        })
        .finally(() => {
            dispatch({
                type: adminSettingsActions.COMPLETE_ADMIN_SETTINGS,
            });
        });
};

export const fetchFolderNotificationsSettings = (): AppThunkAction<KnownActions> => dispatch => {
    dispatch({
        type: adminSettingsActions.REQUEST_FETCH_ADMIN_SETTINGS,
    });
    axios
        .get(`${process.env.REACT_APP_API_URL}/api/Company/GetFolderNotificationSettings`)
        .then((response: any) => {
            const data = response.data;
            dispatch({
                type: adminSettingsActions.RECEIVE_FOLDER_NOTIFICATIONS_SETTINGS,
                payload: data,
            });
        })
        .catch(function (error: any) {
            dispatch({
                type: notifactionAction.NOTIFICATION,
                statusMessage: error.message,
                statusType: StatusType.Error,
            });
            dispatch({
                type: adminSettingsActions.COMPLETE_ADMIN_SETTINGS,
            });
        });
};

export const fetchFileTypeSettings = (): AppThunkAction<KnownActions> => dispatch => {
    dispatch({
        type: adminSettingsActions.REQUEST_FETCH_ADMIN_SETTINGS,
    });
    axios
        .get(`${process.env.REACT_APP_API_URL}/api/Company/GetFileTypeSettings`)
        .then((response: any) => {
            const data = response.data;
            dispatch({
                type: adminSettingsActions.RECEIVE_FILE_TYPE_SETTINGS,
                payload: data,
            });
        })
        .catch(function (error: any) {
            dispatch({
                type: notifactionAction.NOTIFICATION,
                statusMessage: error.message,
                statusType: StatusType.Error,
            });
            dispatch({
                type: adminSettingsActions.COMPLETE_ADMIN_SETTINGS,
            });
        });
};
